<form [formGroup]="registroActividadLaboratorioFormGroup">
  <br>
  <h4 class="secondary-header"> Datos del laboratorio</h4>
  <div class="row">
    <mat-form-field class="col-12">
      <input matInput placeholder="Nombre:" formControlName="nombre" required>
      <mat-error *ngIf="registroActividadLaboratorioFormGroup.get('nombre')?.hasError('required')">
        Debe ingresar nombre del laboratorio
      </mat-error>
    </mat-form-field>
  </div>
  <ng-container *ngIf="isLoaded">
    <div>
      <h4 class="secondary-header"> Domicilio</h4>
    </div>
    <rpe-direcciones-geograficas-form [formInput]="direccionGeograficaFormInput"
      (formStatusChanges)="direccionGeograficaStatusChange($event)"
      (formValueChanges)="direccionGeograficaChange($event)" [withCountryOption]="false">
    </rpe-direcciones-geograficas-form>
  </ng-container>
  <div>
    <h4 class="secondary-header"> Contacto del laboratorio</h4>
  </div>
  <rpe-datos-contacto-form [formInput]="datosContactoFormInput" (formStatusChanges)="datosContactoStatusChange($event)"
    (formValueChanges)="datosContactoChange($event)"></rpe-datos-contacto-form>
  <rpe-registro-actividad-laboratorio-equipamiento-form [formInput]="equipamientoFormInput"
    (formStatusChanges)="equipamientoStatusChange($event)" (formValueChanges)="equipamientoChange($event)">
  </rpe-registro-actividad-laboratorio-equipamiento-form>
  <hr>
</form>
